module.exports = __webpack_public_path__ + "static/media/sidebar-sms.f9500876.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-sms.svg
// module id = 789
// module chunks = 0